import type { History } from 'history';
import { createHistory } from '.';
import type { BridgeConfig } from './types';

export const createBridgeApi = (
	bridge: BridgeConfig | undefined,
	args: {
		userConsentRequired: boolean;
	},
): {
	changeWindowTitle: (payload?: any) => Promise<any>;
	close: (payload?: any) => Promise<any>;
	closeFlag: (payload?: any) => Promise<any>;
	createHistory: () => History<unknown> | undefined;
	onClose: (payload?: any) => Promise<any>;
	onError: (payload?: any) => Promise<any>;
	open: (payload?: any) => Promise<any>;
	openModal: (payload?: any) => Promise<any>;
	reconcile: (payload?: any) => Promise<any>;
	refresh: (payload?: any) => Promise<any>;
	showFlag: (payload?: any) => Promise<any>;
	submit: (payload?: any) => Promise<any>;
} => {
	const { userConsentRequired } = args;

	return {
		refresh: createBridgeMethod(bridge?.refresh),
		submit: createBridgeMethod(bridge?.submit),
		open: createBridgeMethod(bridge?.open),
		close: createBridgeMethod(bridge?.close),
		onClose: createBridgeMethod(bridge?.onClose),
		openModal: createBridgeMethod(bridge?.openModal, {
			requiresUserConsent: userConsentRequired,
		}),
		showFlag: createBridgeMethod(bridge?.showFlag),
		closeFlag: createBridgeMethod(bridge?.closeFlag),
		reconcile: createBridgeMethod(bridge?.reconcile),
		onError: createBridgeMethod(bridge?.onError),
		createHistory: (): History<unknown> | undefined =>
			createHistory({
				history: bridge?.history,
				extensionBasePath: bridge?.extensionBasePath,
			}),
		changeWindowTitle: createBridgeMethod(bridge?.changeWindowTitle),
	};
};

const createBridgeMethod = (method?: Function, ...args: any[]) => {
	return async (payload?: any) => {
		if (method) {
			return method(payload, ...args) ?? true;
		}
		return false;
	};
};
